import { z } from 'zod';

const CategorySchema = z.object({
  id: z.string(),
  name: z.string(),
  level: z.number(),
});

const TagSchema = z.object({
  id: z.string(),
  name: z.string(),
  categoryName: z.string(),
  userHasAccess: z.boolean().optional(),
  get children() {
    return z.array(TagSchema);
  },
});

export type PlanLabel = z.infer<typeof TagSchema>;

const HierarchySchema = z.object({
  id: z.string(),
  name: z.string(),
  categories: z.array(CategorySchema),
  tags: z.array(TagSchema),
});

export const treeDataResponseSchema = z.array(HierarchySchema);

export const updateTagsRequestSchema = z.array(z.string());
export const updateTagsResponseSchema = z.unknown();

export const sanitizeTagsRequestSchema = z.array(z.string());
const SanitizedTagSchema = z.object({
  id: z.string(),
  name: z.string(),
  urn: z.string(),
  categoryId: z.string(),
  hierarchyId: z.string(),
});

export type SanitizedTag = z.infer<typeof SanitizedTagSchema>;

export const sanitizeTagsResponseSchema = z.array(SanitizedTagSchema);
